import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';

import type { Styles } from 'src/theme/themes';

export const styles = {
  tableContainer: (theme) => ({
    width: '100%',
    boxShadow: '0px 4px 23px 0px #00000014',
    border: '1px solid',
    borderColor: theme.colors.neutral[100],
  }),
  tablePagination: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  tableCell: (theme, isHead?: boolean) => ({
    maxWidth: '200px',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    height: '48px',
    padding: isHead ? '16px 0 0 16px' : '8px 16px',
    color: isHead ? theme.colors.neutral[600] : theme.colors.neutral[500],
    fontWeight: isHead ? 600 : 500,
  }),
  npsScore: {
    borderRadius: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    fontWeight: 600,
  },
  statusPill: {
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 600,
    borderRadius: '27px',
    padding: '4px 16px',
    width: 'max-content',
  },
} satisfies Styles & {
  tableCell: (theme: Theme, isHead?: boolean) => SystemStyleObject<Theme>;
};
